import Vue from 'vue'
import VueRouter  from 'vue-router'

Vue.use(VueRouter)

const routers = [
  {
    path: '',
    hidden: true,
    component: () => import('@/views/index'),
    children: [
      {
        path: '/',
        component: () => import('@/views/home/index')
      },
      {
        path: '/liveStreaming',
        component: () => import('@/views/liveStreaming/index')
      },
      {
        path: '/buyTogether',
        component: () => import('@/views/buyTogether/index')
      },
      {
        path: '/fromFarmToTable',
        component: () => import('@/views/fromFarmToTable/index')
      },
      {
        path: '/convergenceTraining',
        component: () => import('@/views/convergenceTraining/index')
      },
      {
        path: '/nationalPolicy',
        component: () => import('@/views/nationalPolicy/index')
      },
      {
        path: '/articleDetail',
        component: () => import('@/views/article/articleDetail')
      },
      {
        path: '/productDetail',
        component: () => import('@/views/home/productDetail')
      },
      {
        name:'orderDetail',
        path: '/orderDetail',
        component: () => import('@/views/home/orderDetail')
      },
      {
        name:'manager',
        path: '/manager',
        component: () => import('@/views/manager/index'),
        children: [
          {
            name:'setting',
            path: '/setting',
            component: () => import('@/views/manager/setting/index')
          },
          {
            name:'order',
            path: '/order',
            component: () => import('@/views/manager/order/index')
          },
          {
            name:'cart',
            path: '/cart',
            component: () => import('@/views/manager/cart/index')
          },
          {
            name:'comment',
            path: '/comment',
            component: () => import('@/views/manager/comment/index')
          },
        ]
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login')
  },
]

const router = new VueRouter({
  mode: "history",
  routes: routers
});

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

export default router;